import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';

import { useSelector } from '../store/utils';
import {
  WallboxStatus,
  WallboxSubStatus,
} from '../../../core/src/shared/enums';

export const FormattedWallboxStatus = () => {
  const [status, subStatus] = useSelector(
    ({ variables }) =>
      [
        get(variables, 'WB_INFO.Status'),
        get(variables, 'WB_INFO.SubStatus'),
      ] as const
  );

  const statusMapping: Record<WallboxStatus, ReactNode> = {
    [WallboxStatus.NotConnected]: (
      <FormattedMessage
        id="wallbox.status.not_connected"
        defaultMessage="Nelze navázat spojení"
      />
    ),
    [WallboxStatus.Off]: (
      <FormattedMessage
        id="wallbox.status.off"
        defaultMessage="Wallbox vypnutý"
      />
    ),
    [WallboxStatus.Normal]: (
      <FormattedMessage
        id="wallbox.status.normal"
        defaultMessage="Běžný režim"
      />
    ),
    [WallboxStatus.CarNotConnected]: (
      <FormattedMessage
        id="wallbox.status.car_not_connected"
        defaultMessage="Auto není připojeno"
      />
    ),
    [WallboxStatus.Ready]: (
      <FormattedMessage
        id="wallbox.status.ready"
        defaultMessage="Připraveno k nabíjení"
      />
    ),
    [WallboxStatus.Charging]: (
      <FormattedMessage
        id="wallbox.status.charging"
        defaultMessage="Nabíjení"
      />
    ),
    [WallboxStatus.ChargingWithVentilation]: (
      <FormattedMessage
        id="wallbox.status.charging_with_ventilation"
        defaultMessage="Nabíjení auta s ventilátorem"
      />
    ),
    [WallboxStatus.Error]: (
      <FormattedMessage
        id="wallbox.status.error"
        defaultMessage="Chyba nabíjení"
      />
    ),
  };

  const subStatusMapping: Record<WallboxSubStatus, ReactNode> = {
    [WallboxSubStatus.None]: (
      <FormattedMessage id="wallbox.sub_status.none" defaultMessage=" " />
    ),
    [WallboxSubStatus.BasicEnergy]: (
      <FormattedMessage
        id="wallbox.sub_status.basic_energy"
        defaultMessage="základní energií"
      />
    ),
    [WallboxSubStatus.BatteryWaiting]: (
      <FormattedMessage
        id="wallbox.sub_status.battery_waiting"
        defaultMessage=", čekání na nabítí baterie"
      />
    ),
    [WallboxSubStatus.Battery]: (
      <FormattedMessage
        id="wallbox.sub_status.battery"
        defaultMessage="podle baterie"
      />
    ),
    [WallboxSubStatus.BatteryFast]: (
      <FormattedMessage
        id="wallbox.sub_status.battery_fast"
        defaultMessage="přednostně podle baterie"
      />
    ),
    [WallboxSubStatus.Photovoltaics]: (
      <FormattedMessage
        id="wallbox.sub_status.photovoltaics"
        defaultMessage="podle FVE"
      />
    ),
    [WallboxSubStatus.Spot]: (
      <FormattedMessage
        id="wallbox.sub_status.spot"
        defaultMessage="podle SPOTU"
      />
    ),
    [WallboxSubStatus.SpotMid]: (
      <FormattedMessage
        id="wallbox.sub_status.spot_mid"
        defaultMessage=", je střední cena SPOTU"
      />
    ),
    [WallboxSubStatus.SpotHigh]: (
      <FormattedMessage
        id="wallbox.sub_status.spot_high"
        defaultMessage=", je vysoká cena SPOTU"
      />
    ),
    [WallboxSubStatus.Auto]: (
      <FormattedMessage
        id="wallbox.sub_status.auto"
        defaultMessage="podle auto. režimu"
      />
    ),
    [WallboxSubStatus.HDOBlock]: (
      <FormattedMessage
        id="wallbox.sub_status.hdo_block"
        defaultMessage=", blokace HDO"
      />
    ),
    [WallboxSubStatus.Schedule]: (
      <FormattedMessage
        id="wallbox.sub_status.schedule"
        defaultMessage="podle plánovače"
      />
    ),
    [WallboxSubStatus.NoCharging]: (
      <FormattedMessage
        id="wallbox.sub_status.no_charging"
        defaultMessage=", nabíjení je zakázáno"
      />
    ),
  };

  return (
    <>
      {statusMapping[status]} {subStatusMapping[subStatus]}
    </>
  );
};
